export type CookiebotCategory = 'preferences' | 'statistics' | 'marketing'

interface CookiebotGlobal {
	hasResponse: boolean
	consent: Record<CookiebotCategory, boolean>
}

declare global {
	interface Window {
		Cookiebot?: CookiebotGlobal
	}
}

// Calls `onChange` with the visitor's consent for `category` once Cookiebot knows it (stored consent on
// load, or the banner's answer), then again on every change. Cookiebot is injected by GTM, so it may
// load before or after this runs - the current state is read right away if it's already known.
export function watchCookiebotConsent(category: CookiebotCategory, onChange: (granted: boolean) => void) {
	const notify = () => {
		const cookiebot = window.Cookiebot
		if (cookiebot?.hasResponse) {
			onChange(cookiebot.consent[category])
		}
	}

	for (const event of ['CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline']) {
		window.addEventListener(event, notify)
	}
	notify()
}
